import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import AccountInfo from './AccountInfo';
import Notification from './Notification';
import DeleteAccount from './DeleteAccount';
import AboutUs from './AboutUs';
// import Payment from './Payment';

const SETTINGS_TABS = [
  {
    id: 'about',
    label: 'About Us',
    description: 'Mission, values and company info',
    icon: 'mdi:information-outline',
    iconFilled: 'mdi:information',
  },
  // {
  //   id: 'payment',
  //   label: 'Payment',
  //   description: 'Payment history and receipts',
  //   icon: 'mdi:credit-card-outline',
  //   iconFilled: 'mdi:credit-card',
  // },
  {
    id: 'delete',
    label: 'Delete Account',
    description: 'Permanently remove your account',
    icon: 'fluent:delete-24-regular',
    iconFilled: 'fluent:delete-24-filled',
    danger: true,
  },
];

function Settings() {
  const [activeTab, setActiveTab] = useState('about');

  return (
    <div className="settings-page min-h-[60vh]">
      {/* Header */}
      <header className="relative rounded-2xl overflow-hidden mb-8">
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 50%, #6366f1 100%)',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[var(--bg-primary)] via-transparent to-[var(--primary-lighter)] opacity-90" />
        <div className="relative px-6 py-8 sm:px-8 sm:py-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--text-primary)] tracking-tight mb-2">
            Settings
          </h1>
          <p className="text-[var(--text-secondary)] text-base sm:text-lg max-w-xl leading-relaxed">
            Manage your account, payment history, and preferences.
          </p>
        </div>
      </header>

      {/* Tab switcher — card style */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {SETTINGS_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={`settings-tab-card flex items-center gap-4 p-5 rounded-2xl border-2 text-left transition-all duration-300 ${
              activeTab === tab.id
                ? tab.danger
                  ? 'border-red-400 bg-red-50 dark:bg-red-950/20'
                  : 'border-[var(--primary-color)] bg-[var(--primary-color)]/10 shadow-lg shadow-[var(--primary-color)]/10'
                : 'border-[var(--border-color)] bg-[var(--bg-primary)] hover:border-[var(--primary-lighter)] hover:bg-[var(--primary-color)]/5'
            }`}
          >
            <div
              className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center ${
                activeTab === tab.id
                  ? tab.danger
                    ? 'bg-red-500 text-white'
                    : 'bg-[var(--primary-color)] text-white'
                  : tab.danger
                    ? 'bg-red-100 text-red-600'
                    : 'bg-[var(--bg-tertiary)] text-[var(--text-secondary)]'
              }`}
            >
              <Icon icon={activeTab === tab.id ? tab.iconFilled : tab.icon} width={26} height={26} />
            </div>
            <div className="min-w-0">
              <span
                className={`block text-base font-semibold ${
                  activeTab === tab.id
                    ? tab.danger
                      ? 'text-red-700'
                      : 'text-[var(--primary-color)]'
                    : 'text-[var(--text-primary)]'
                }`}
              >
                {tab.label}
              </span>
              <span className="block text-sm text-[var(--text-secondary)] mt-0.5 truncate">
                {tab.description}
              </span>
            </div>
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="bg-[var(--bg-primary)] rounded-2xl border border-[var(--border-color)] shadow-sm overflow-hidden">
        {activeTab === 'account' && (
          <div className="animate-fade-in p-6 sm:p-8">
            <AccountInfo />
          </div>
        )}
        {activeTab === 'notifications' && (
          <div className="animate-fade-in p-6 sm:p-8">
            <Notification />
          </div>
        )}
        {activeTab === 'about' && (
          <div className="animate-fade-in p-6 sm:p-8">
            <AboutUs />
          </div>
        )}
        {/* {activeTab === 'payment' && (
          <div className="animate-fade-in p-6 sm:p-8">
            <Payment />
          </div>
        )} */}
        {activeTab === 'delete' && (
          <div className="animate-fade-in p-6 sm:p-8">
            <DeleteAccount />
          </div>
        )}
      </div>
    </div>
  );
}

export default Settings;
